import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { JotaiProvider } from '@/lib/jotai-provider';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <JotaiProvider>
      <App />
    </JotaiProvider>
  </StrictMode>
);
